import { Stack } from "@mui/material";

import {
	ScimWizardConfirmationListHeader, ScimWizardMappedIcon, ScimWizardResourceList,
	ScimWizardResourceListHeader, ScimWizardResourceListItem, ScimWizardResourceListTitle,
	ScimWizardResourceNameTypography, ScimWizardUnmappedIcon
} from "./styled/scim-wizard.styled";

export default function ScimWizardConfirmList(props: any) {
	const { mapped, unmapped, resource } = props;
	return (
		<div>
			<ScimWizardConfirmationListHeader variant="h6">CoApp {resource}</ScimWizardConfirmationListHeader>
			<Stack direction="row" spacing={3}>
				<ScimWizardResourceList ismapped="true">
					<ScimWizardResourceListHeader ismapped="true">
						<Stack direction="row" sx={{ justifyContent: "space-between" }}>
							<ScimWizardResourceListTitle variant="body1">Mapped</ScimWizardResourceListTitle>
							<ScimWizardMappedIcon />
						</Stack>
					</ScimWizardResourceListHeader>
					{
						mapped.map((item: any) => (
							<ScimWizardResourceListItem key={item}>
								<ScimWizardResourceNameTypography title={item} key={item} variant="body2" noWrap={true}>{item}</ScimWizardResourceNameTypography>
							</ScimWizardResourceListItem>
						))
					}
				</ScimWizardResourceList>
				<ScimWizardResourceList>
					<ScimWizardResourceListHeader>
						<Stack direction="row" sx={{ justifyContent: "space-between" }}>
							<ScimWizardResourceListTitle variant="body1">Unmapped</ScimWizardResourceListTitle>
							<ScimWizardUnmappedIcon />
						</Stack>
					</ScimWizardResourceListHeader>
					{
						unmapped.map((item: any) => (
							<ScimWizardResourceListItem key={item}>
								<ScimWizardResourceNameTypography title={item} key={item} variant="body2" noWrap={true}>{item}</ScimWizardResourceNameTypography>
							</ScimWizardResourceListItem>
						))
					}
				</ScimWizardResourceList>
			</Stack>
		</div>
	);
}